import {
  BookOpen,
  Building2,
  GraduationCap,
  FlaskConical,
  Coffee,
  Store,
  Landmark,
  LayoutGrid,
  MapPin,
  Bell,
  Newspaper,
  FileText,
  MessageSquare,
  Home,
} from 'lucide-react';

/**
 * Single source of truth for "content categories" used by the navbar
 * mega-menu (desktop) and the mobile drawer.
 *
 * Keep the ordering intentional — the first four entries are the "primary"
 * categories, the rest are grouped as "More on campus".
 */
export const CATEGORY_GROUPS = [
  {
    label: 'Explore',
    items: [
      {
        name: 'Faculties',
        path: '/faculties',
        description: 'Colleges & academic faculties',
        icon: BookOpen,
      },
      {
        name: 'Departments',
        path: '/departments',
        description: 'All departments & programmes',
        icon: Building2,
      },
      {
        name: 'Facilities',
        path: '/facilities',
        description: 'Libraries, halls & labs',
        icon: Landmark,
      },
      {
        name: 'Amenities',
        path: '/facilities',
        state: { activeTab: 'amenity' },
        description: 'Cafeterias, banks & more',
        icon: Coffee,
      },
      {
        name: 'Postgraduate',
        path: '/postgraduate',
        description: 'School of Postgraduate Studies',
        icon: GraduationCap,
      },
      {
        name: 'Research',
        path: '/research',
        description: 'Research centres & units',
        icon: FlaskConical,
      },
      {
        name: 'SCEDL',
        path: '/scedl',
        description: 'Continuing education & distance learning',
        icon: BookOpen,
      },
    ],
  },
  {
    label: 'Campus Life',
    items: [
      {
        name: 'Business & Services',
        path: '/facilities',
        state: { activeTab: 'business_center' },
        description: 'Shops, cafes & services',
        icon: Store,
      },
      {
        name: 'Administration',
        path: '/administration',
        description: 'Administrative offices',
        icon: LayoutGrid,
      },
      {
        name: 'Campus Map',
        path: '/map',
        description: 'Find any spot on campus',
        icon: MapPin,
      },
      {
        name: 'Notices',
        path: '/notices',
        description: 'Official announcements',
        icon: Bell,
      },
      {
        name: 'Updates',
        path: '/updates',
        description: 'Latest campus news',
        icon: Newspaper,
      },
      {
        name: 'Documents',
        path: '/documents',
        description: 'Forms & publications',
        icon: FileText,
      },
    ],
  },
];

/** Flat list — handy for iterating / rendering a single responsive grid. */
export const ALL_CATEGORIES = CATEGORY_GROUPS.flatMap((group) =>
  group.items.map((item) => ({ ...item, group: group.label }))
);

/** Standalone links that stay visible in the desktop navbar (not in the menu). */
export const PRIMARY_NAV_LINKS = [
  { name: 'Home', path: '/' },
  { name: 'Faculties', path: '/faculties' },
  { name: 'Departments', path: '/departments' },
  { name: 'Campus Map', path: '/map' },
];

/** Secondary utility links shown at the far right of the desktop navbar. */
export const UTILITY_NAV_LINKS = [
  { name: 'Notices', path: '/notices' },
  { name: 'Updates', path: '/updates' },
  { name: 'Talk to AI 🚀', path: '/chat' },
];

export const HOME_ICON = Home;
export const CHAT_ICON = MessageSquare;

export default CATEGORY_GROUPS;